import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Router, ActivatedRoute } from "@angular/router";
import { UserService } from "src/app/shared/user.service";
import { environment } from "src/environments/environment";
import { Role } from "./role.model";
import { Users } from "src/app/shared/users.model";
import { ModulesSubmodulesPermissionsMaster } from "./modules-submodules-permissions-master.model";
import { ModulesSubmodulesPermissionsByRole } from "./modules-submodules-permissions-by-role.model";
import { AllPermissiosnMaster } from "./all-permissions-master.model";
import { Userrole } from "./userrole.model";
import { promise } from "protractor";
import { Organisation } from "src/app/shared/organisation.model";
import { Onboarding } from "src/app/shared/onboarding.model";


@Injectable({
  providedIn: "root",
})
export class UserManagementService {
  contractBaseUrl: String;
  contracttypeBaseUrl: String;
  thisRole: Role = new Role();
  allroles: Role[];
  thisUser: Users;
  organisation: Organisation
  allUsers: Users[];
  thisUserRole: Userrole[] = [];
  modulesSubmodulesPermissionsMaster: ModulesSubmodulesPermissionsMaster =
    new ModulesSubmodulesPermissionsMaster();
  thisUserModulePermissionRoles: ModulesSubmodulesPermissionsByRole[] = [];

  userCreationConfirmationAlert: Boolean = false;

  alertMessage: string = "";
  thisPermissionsMater: AllPermissiosnMaster[] = null;
  constructor(
    private http: HttpClient,
    private router: Router,
    public userService: UserService,
    private route: ActivatedRoute
  ) {
    this.contractBaseUrl = environment.contractApiURL;
    this.contracttypeBaseUrl = environment.contractTypeApiURL;
  }

  createRole() {
    return new Promise((resolve, reject) => {
      this.thisRole.updatedBy =
        this.userService.loggedinUser.firstName +
        " " +
        this.userService.loggedinUser.lastName;
      this.thisRole.createdBy =
        this.userService.loggedinUser.firstName +
        " " +
        this.userService.loggedinUser.lastName;
      this.http
        .post(
          this.contractBaseUrl +
          "/tenants/" +
          this.userService.loggedinUser.tenantId +
          "/roles",
          this.thisRole
        )
        .toPromise()
        .then((res: Role) => {
          this.thisRole = res as Role;
          resolve(true);
        });
    });
  }
  createPermissions() {
    return new Promise((resolve, reject) => {
      this.http
        .post(
          this.contractBaseUrl +
          "/tenants/" +
          this.userService.loggedinUser.tenantId +
          "/roleModuleSubModulePermission",
          this.thisUserModulePermissionRoles
        )
        .toPromise()
        .then((res: ModulesSubmodulesPermissionsByRole[]) => {
          this.thisUserModulePermissionRoles =
            res as ModulesSubmodulesPermissionsByRole[];
          resolve(true);
        });
    });
  }
  getPermissions(id: string) {
    return new Promise((resolve, reject) => {
      this.http
        .get(
          this.contractBaseUrl +
          "/tenants/" +
          this.userService.loggedinUser.tenantId +
          "/roleModuleSubModulePermission/roles/" +
          id
        )
        .toPromise()
        .then((res: ModulesSubmodulesPermissionsByRole[]) => {
          this.thisUserModulePermissionRoles =
            res as ModulesSubmodulesPermissionsByRole[];
          resolve(true);
        });
    });
  }
  updatePermissions() {
    return new Promise((resolve, reject) => {
      this.http
        .put(
          this.contractBaseUrl +
          "/tenants/" +
          this.userService.loggedinUser.tenantId +
          "/roleModuleSubModulePermission/role/" +
          this.thisRole.id,
          this.thisUserModulePermissionRoles
        )
        .toPromise()
        .then((res: ModulesSubmodulesPermissionsByRole[]) => {
          this.thisUserModulePermissionRoles =
            res as ModulesSubmodulesPermissionsByRole[];
          resolve(true);
        });
    });
  }
  // updateRole(data) {
  //   return new Promise((resolve, reject) => {
  //     data.updatedBy =
  //       this.userService.loggedinUser.firstName +
  //       " " +
  //       this.userService.loggedinUser.lastName;
  //     data.updateDate = new Date();
  //     this.http
  //       .put(
  //         this.contractBaseUrl +
  //         "/tenants/" +
  //         this.userService.loggedinUser.tenantId +
  //         "/roles/" +
  //         data.id,
  //         data
  //       )
  //       .toPromise()
  //       .then((res: Role) => {
  //         this.thisRole = res as Role;
  //         resolve(res);
  //       });
  //   });
  // }
  updateRole(){
    return new Promise((resolve, reject)=>{
      this.thisRole.updatedBy = this.userService.loggedinUser.firstName+" "+this.userService.loggedinUser.lastName;
     // this.thisRole.createdBy = this.userService.loggedinUser.firstName+" "+this.userService.loggedinUser.lastName;
      this.http.put(this.contractBaseUrl+'/tenants/'+this.userService.loggedinUser.tenantId+'/roles/'+this.thisRole.id,this.thisRole).toPromise().then((res:Role) => {
        this.thisRole = res as Role;
       resolve(true);
      })

    });
  }
  getRole(id: string) {
    return new Promise((resolve, reject) => {
      this.http
        .get(
          this.contractBaseUrl +
          "/tenants/" +
          this.userService.loggedinUser.tenantId +
          "/roles/" +
          id
        )
        .toPromise()
        .then((res: Role) => {
          this.thisRole = res as Role;
          resolve(true);
        });
    });
  }
  getAllRoles() {
    return new Promise((resolve, reject) => {
      this.http
        .get(
          this.contractBaseUrl +
          "/tenants/" +
          this.userService.loggedinUser.tenantId +
          "/roles"
        )
        .toPromise()
        .then((res: Role[]) => {
          this.allroles = res as Role[];
          resolve(this.allroles);
        });
    });
  }
  ///////organisation-list////////////////
  getAllOrg() {
    return new Promise((resolve, reject) => {
      this.http.get(this.contractBaseUrl + "/tenants/")
        .toPromise()
        .then((res: any) => {
          resolve(res);
        });
    });
  }
  getOrgById() {
    return new Promise((resolve, reject) => {
      this.http.get(this.contractBaseUrl + "/tenants/"+ this.userService.loggedinUser.tenantId)
        .toPromise()
        .then((res: any) => {
          resolve(res);
          console.log(res,'res')
        });
    });
  }
  deleteOrg(id: number) {
    return new Promise((resolve, reject) => {
      this.http
        .delete(
          this.contractBaseUrl +
          "/tenants/" + id
        )
        .toPromise()
        .then((res: any) => {
          resolve(true);
        }).catch((error) => {
          reject(false);
        });
    });
  }

  toggleOrgStatus(data) {
    return new Promise((resolve, reject) => {
      let obj = {
        status: data.status === 1 ? 0 : 1,
        updatedBy: this.userService.loggedinUser.firstName + " " + this.userService.loggedinUser.lastName,
        updateDate: new Date()
      };
      // data.status = data.status === 1 ? 0 : 1;
      // data.updatedBy =
      //   this.userService.loggedinUser.firstName +
      //   " " +
      //   this.userService.loggedinUser.lastName;
      // data.updateDate = new Date();


      let url =
        this.contractBaseUrl +
        `/tenants/activat/${data.id}`
      this.http
        .put(url, obj)
        .toPromise()
        .then((res: Organisation) => {
          this.organisation = res as Organisation;

          resolve(res);
        }).catch((error) => {
          reject(error);
        });;
    });
  }
  getTenetById(id: any) {
    return new Promise((resolve, reject) => {
      this.http
        .get(
          this.contractBaseUrl +
          "/tenants/" + id
        )
        .toPromise()
        .then((res: Onboarding) => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
    });
  }
  getPlanById(id: string) {
    return new Promise((resolve, rejects) => {
      this.http.get(this.contractBaseUrl + "/plans/" + id)
        .toPromise()
        .then((res: any) => {
          resolve(res);
        })
    })
  }


  addOrg(data, file: File) {
    const formData = new FormData();
    if(file)
      formData.append("organisationLogo", file);
    else 
      formData.append("organisationLogo", null);
    const additionalProperties = {
      createDate: new Date(),
      updateDate: new Date(),
      createdBy: this.userService.loggedinUser.id.toString(),
      updatedBy: this.userService.loggedinUser.id.toString()
    };
    const requestData = { ...data, ...additionalProperties };
    let params = new URLSearchParams();
    for (let key in requestData) {
      params.set(key, requestData[key]);
    }
    return new Promise((resolve, reject) => {
      this.http.post(this.contractBaseUrl + `/tenants?` + params.toString(), formData)
        .toPromise()
        .then((res: any) => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        })
    })
  }

  getAllUsers() {
    return new Promise((resolve, reject) => {
      this.http
        .get(
          this.contractBaseUrl +
          "/tenants/" +
          this.userService.loggedinUser.tenantId +
          "/users"
        )
        .toPromise()
        .then((res: Users[]) => {
          this.allUsers = res as Users[];
          resolve(res);
        });
    });
  }

  createUser(data, activate = false, file: File) {
    let userName;
    if (this.userService.loggedinUser.middleName)
      userName = this.userService.loggedinUser.firstName + " " + this.userService.loggedinUser.middleName + " " + this.userService.loggedinUser.lastName;
    else
      userName = this.userService.loggedinUser.firstName + " " + this.userService.loggedinUser.lastName;

    const additionalProperties = {
      createDate: new Date(),
      updateDate: new Date(),
      createdBy: userName,
      updatedBy: userName,
      tenantId: this.userService.loggedinUser.tenantId,
      status: activate ? 1 : 0
    };
    const requestData = { ...data, ...additionalProperties };
    return new Promise((resolve, reject) => {
      let url =
        this.contractBaseUrl +
        "/tenants/" +
        this.userService.loggedinUser.tenantId +
        "/users";

      this.http
        .post(url, requestData)
        .toPromise()
        .then((res: Users) => {
          this.thisUser = res as Users;
          resolve(res);
          if(file)
            this.updateUserImage(file, res.id);
        }).catch((error) => {
          reject(error);
        });
    });
  }

  sendMail(emailId: string) {
    return this.http
      .get(this.contractBaseUrl + "/userwelcomemail?email=" + emailId, {
        responseType: "text",
      })
      .toPromise();
  }

  toggleUserStatus(data) {
    return new Promise((resolve, reject) => {
      let obj = {
        status: data.status === 1 ? 0 : 1,
        updatedBy: this.userService.loggedinUser.firstName + " " + this.userService.loggedinUser.lastName,
        updateDate: new Date()
      };
      data.status = data.status === 1 ? 0 : 1;
      data.updatedBy =
        this.userService.loggedinUser.firstName +
        " " +
        this.userService.loggedinUser.lastName;
      data.updateDate = new Date();


      let url =
        this.contractBaseUrl +
        "/tenants/" +
        this.userService.loggedinUser.tenantId +
        "/users/" +
        data.id;
      this.http
        .put(url, obj)
        .toPromise()
        .then((res: Users) => {
          this.thisUser = res as Users;

          resolve(res);
        }).catch((error) => {
          reject(error);
        });;
    });
  }

  updateUserImage(img, userId) {
    const formdata = new FormData();
    formdata.append("profileImage", img, img.name);
    return new Promise((resolve, reject) => {
      let url =
        this.contractBaseUrl +
        "/tenants/" +
        this.userService.loggedinUser.tenantId +
        "/users/" +
        userId + '/uploadProfileImage';

      this.http
        .put(url, formdata)
        .toPromise()
        .then((res) => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
    });
  }

  updateOrgImage(img, tenantId) {
    const formdata = new FormData();
    formdata.append("orgLogo", img, img.name);
    return new Promise((resolve, reject) => {
      let url =
        this.contractBaseUrl +
        "/tenants/" +
        tenantId + '/uploadOrganisationLogo';

      this.http
        .put(url, formdata)
        .toPromise()
        .then((res) => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
    });
  }

  updateUser(data) {
    return new Promise((resolve, reject) => {
      data.updatedBy =
        this.userService.loggedinUser.firstName +
        " " +
        this.userService.loggedinUser.lastName;
      data.updateDate = new Date();
      delete data.password;
      let url =
        this.contractBaseUrl +
        "/tenants/" +
        this.userService.loggedinUser.tenantId +
        "/users/" +
        data.id;
      this.http
        .put(url, data)
        .toPromise()
        .then((res: Users) => {
          this.thisUser = res as Users;

          resolve(res);
        }).catch((error) => {
          reject(false);
        });
    });
  }
  deleteUser(id: number) {
    return new Promise((resolve, reject) => {
      this.http
        .delete(
          this.contractBaseUrl +
          "/tenants/" +
          this.userService.loggedinUser.tenantId +
          "/users/" +
          id
        )
        .toPromise()
        .then((res: any) => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
    });
  }

  deleteRole(id: number) {
    return new Promise((resolve, reject) => {
      this.http
        .delete(
          this.contractBaseUrl +
          "/tenants/" +
          this.userService.loggedinUser.tenantId +
          "/roles/" +
          id
        )
        .toPromise()
        .then((res: any) => {
          resolve(true);
        }).catch((error) => {
          reject(false);
        });
    });
  }

  getRolesOfAUser(id: string) {
    return new Promise((resolve, reject) => {
      this.http
        .get(
          this.contractBaseUrl +
          "/tenants/" +
          this.userService.loggedinUser.tenantId +
          "/usersRoles/users/" +
          id
        )
        .toPromise()
        .then((res: Userrole[]) => {
          this.thisUserRole = res as Userrole[];

          resolve(res);
        }).catch((error) => {
          reject(false);
        });;
    });
  }
  createUserRole(data) {
    return new Promise((resolve, reject) => {
      this.http
        .post(
          this.contractBaseUrl +
          "/tenants/" +
          this.userService.loggedinUser.tenantId +
          "/usersRoles",
          data
        )
        .toPromise()
        .then((res: Userrole[]) => {
          this.thisUserRole = res as Userrole[];

          resolve(true);
        });
    });
  }
  updateUserRole(id, data) {
    return new Promise((resolve, reject) => {
      this.http
        .put(
          this.contractBaseUrl +
          "/tenants/" +
          this.userService.loggedinUser.tenantId +
          "/usersRoles/users/" +
          id,
          data
        )
        .toPromise()
        .then((res: Userrole[]) => {
          this.thisUserRole = res as Userrole[];

          resolve(res);
        });
    });
  }
  getAUser(id: string) {
    return new Promise((resolve, reject) => {
      this.http
        .get(
          this.contractBaseUrl +
          "/tenants/" +
          this.userService.loggedinUser.tenantId +
          "/users/" +
          id
        )
        .toPromise()
        .then((res: Users) => {
          this.thisUser = res as Users;
          resolve(res);
        });
    });
  }
  getmodulesSubmodulesPermissionsMaster() {
    return new Promise((resolve, reject) => {
      // tslint:disable-next-line:max-line-length
      this.http
        .get(this.contractBaseUrl + "/modulesSubmodulesPermissions")
        .toPromise()
        .then((res: ModulesSubmodulesPermissionsMaster) => {
          this.modulesSubmodulesPermissionsMaster =
            res as ModulesSubmodulesPermissionsMaster;
          resolve(res);
        });
    });
  }
  getAllPermissionsMaster() {
    return new Promise((resolve, reject) => {
      // tslint:disable-next-line:max-line-length
      this.http
        .get(this.contractBaseUrl + "/permissions")
        .toPromise()
        .then((res: AllPermissiosnMaster[]) => {
          this.thisPermissionsMater = res as AllPermissiosnMaster[];
          resolve(res);
        });
    });
  }

}
